import './styles/sanitize.css'
import './styles/variables.css'
import './styles/base.css'
import './styles/text.css'
import { RecoilRoot } from 'recoil'
import { RouterProvider } from 'react-router-dom'
import router from './navigation'
import EventsSubscriptionsProvider from './services/eventBus/components/EventsSubscriptionsProvider'
import MediaPreviewService from './services/MediaPreviewService'
import ConfirmService from '@/services/ConfirmService'
import AlertsService from '@/services/alerts'

function App() {
  return (
    <RecoilRoot>
      <EventsSubscriptionsProvider>
        <MediaPreviewService />
        <AlertsService />
        <ConfirmService />
        <RouterProvider router={router} />
      </EventsSubscriptionsProvider>
    </RecoilRoot>
  )
}

export default App
